import { PayloadAction } from '@reduxjs/toolkit';
import { CmsConfigs, Operation } from '../../models';
import { RTKQueryAction } from '../core';
import { GeneralState } from './general.slice';

export const addLoaderFullPageReducer = (
  state: GeneralState,
  action: PayloadAction<string>
) => {
  state.loadersFullPage.push(action.payload);
};

export const removeLoaderFullPageReducer = (
  state: GeneralState,
  action: PayloadAction<string>
) => {
  const fullPageLoaderIndex = state.loadersFullPage.findIndex(
    (l) => l === action.payload
  );
  state.loadersFullPage.splice(fullPageLoaderIndex, 1);
};

export const isAppInitializedReducer = (
  state: GeneralState,
  action: PayloadAction<boolean>
) => {
  state.isAppInitialized = action.payload;
};

export const setCmsConfigReducer = (
  state: GeneralState,
  { payload }: RTKQueryAction<CmsConfigs, undefined>
) => {
  state.cmsConfigs = payload;
};

export const setCurrentOrderIdReducer = (
  state: GeneralState,
  { payload }: PayloadAction<string>
) => {
  state.currentOrderId = payload;
};

export const setErrorDescriptionReducer = (
  state: GeneralState,
  { payload }: PayloadAction<string | null>
) => {
  state.errorDescription = payload;
};

export const addRouteToHistoryReducer = (
  state: GeneralState,
  { payload }: PayloadAction<string>
) => {
  state.routesHistory.push(payload);
};

export const removeLastRouteFromHistoryReducer = (state: GeneralState) => {
  if (state.routesHistory.length > 0) {
    state.routesHistory.pop();
  }
};

export const replaceLastRouteFromHistoryReducer = (
  state: GeneralState,
  action: PayloadAction<string>
) => {
  if (state.routesHistory.length > 0) {
    state.routesHistory.pop();
  }
  state.routesHistory.push(action.payload);
};

export const setOperationReducer = (
  state: GeneralState,
  action: PayloadAction<Operation | null>
) => {
  state.operation = action.payload;
};
